// const hamburger = document.getElementById('hamburger');
// const navMenu = document.getElementById('navMenu');

// hamburger.addEventListener('click', () => {
//   hamburger.classList.toggle('active');
//   navMenu.classList.toggle('active');
// });


// const acc_ttl = Array.from(
//   document.querySelectorAll(".hamburger__nav--main > li > a")
// );

// for (let i = 0; i < acc_ttl.length; i++) {
//   let ttl = acc_ttl[i];
//   let content = ttl.nextElementSibling;
//   ttl.addEventListener("click", () => {
//       ttl.classList.toggle("is_active");
//       console.log(content.style.height);
//       if (content.style.height) {
//           content.style.height = null;
//       } else {
//           content.style.height = content.scrollHeight + "px";
//       }
//   });
// }




    // modal
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.js-modalOpen').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          const target = this.dataset.modaltarget;
          const modal = document.getElementById(target);
          if (modal) {
            modal.classList.add('is-visible');
          }
        });
      });
      document.querySelectorAll('.js-modalClose').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          document.querySelectorAll('.js-modal').forEach(function (modal) {
            modal.classList.remove('is-visible');
          });
        });
      });
    });